export default "__VITE_ASSET__CgnSfWNM__"